var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reportFooter"},[_c('span',[_vm._v("Works better than pen and paper")]),_vm._v(" "),_c('span',{staticClass:"dotag-logo-gray"}),_vm._v(" "),_c('span',[_vm._v("Visit today dotag.com")])])
}]

export { render, staticRenderFns }